/* NEWSLETTER SPAM PROTECTION */

export function initNewsletterSpamProtection() {
  const forms = document.querySelectorAll('form[action*="convertkit.com"], form[action*="kit.com"], form.kit-signup-form');
  if (!forms.length) return;

  const pageLoadTime = Date.now();

  forms.forEach(form => {
    const honeypot = document.createElement('input');
    honeypot.type = 'text';
    honeypot.name = '_gotcha';
    honeypot.setAttribute('style', 'display:none;position:absolute;left:-9999px;');
    honeypot.tabIndex = -1;
    honeypot.autocomplete = 'off';
    form.appendChild(honeypot);

    form.addEventListener('submit', (e) => {
      if (honeypot.value || Date.now() - pageLoadTime < 3000) {
        e.preventDefault();
      }
    });
  });
}